import type { TaskSummary } from '../../../api/types'
import { Badge } from '../../../components/ui/Badge'
import { PriorityBadge } from './PriorityBadge'
import { DueDatePill } from './DueDatePill'
import { AssigneeStack } from './AssigneeStack'
import { ProgressBar } from './ProgressBar'
import styles from './TaskCard.module.css'

interface TaskCardProps {
  task: TaskSummary
  onClick: () => void
  dragHandleProps?: Record<string, unknown>
  isDragging?: boolean
}

export function TaskCard({ task, onClick, dragHandleProps, isDragging }: TaskCardProps) {
  return (
    <div
      className={[styles.card, isDragging ? styles.dragging : ''].join(' ')}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onClick()}
      {...dragHandleProps}
    >
      {task.labels.length > 0 ? (
        <div className={styles.labelsRow}>
          {task.labels.map((l) => (
            <Badge key={l.labelId} style={{ background: `${l.label.color}22`, color: l.label.color }}>
              {l.label.name}
            </Badge>
          ))}
        </div>
      ) : null}

      <div className={styles.title}>{task.title}</div>

      <ProgressBar value={task.progress} size="sm" />

      <div className={styles.footer}>
        <div className={styles.metaRow}>
          <PriorityBadge priority={task.priority} />
          <DueDatePill dueDate={task.dueDate} isDone={task.status.isDone} />
          {task._count.checklistItems > 0 ? <span>☑ {task._count.checklistItems}</span> : null}
          {task._count.comments > 0 ? <span>💬 {task._count.comments}</span> : null}
          {task._count.subtasks > 0 ? <span>⎘ {task._count.subtasks}</span> : null}
          {task.technicalScope ? <span title="Technischer Scope vorhanden">🛠</span> : null}
          {task.aiWorkInstruction ? <span title="KI-Arbeitsauftrag vorhanden">🤖</span> : null}
        </div>
        <AssigneeStack users={task.assignees.map((a) => a.user)} />
      </div>
    </div>
  )
}
